import annotations from "@/store/modules/annotations";
import { computed } from "@vue/composition-api";

export default function useTags() {
  const availableTags = [
    {
      value: "duplicate",
      name: "Duplicate"
    },
    {
      value: "notValid",
      name: "Not Valid"
    }
  ];

  const tags = computed(() => annotations.getTags);
  const tagObject = computed(() => {
    // If tag is undefined, return undefined object.
    if (!tags.value) {
      return {
        value: null,
        name: "Undefined"
      };
    }
    // If tags is empty, return None.
    if (tags.value.length < 1) {
      return {
        value: null,
        name: "None"
      };
    }
    // If the tag is in availableTags, return valid tag object.
    const tagValue = tags.value[0];
    const tagObject = availableTags.find(o => o.value === tagValue);
    if (tagObject) return tagObject;
    // Else, return an object with the name property set to the tag's value.
    else
      return {
        value: tagValue,
        name: tagValue
      };
  });

  const syncTags = async newTags => {
    // Save the original tags for rewinding.
    const originalTags = annotations.tags;
    // Set new tags.
    annotations.setTags(newTags);
    try {
      // Save current annotations state to server.
      await annotations.postAnnotations(annotations);
    } catch (error) {
      // Revert change.
      annotations.setTags(originalTags);
      throw error;
    }
  };

  return {
    tags,
    tagObject,
    availableTags,
    syncTags
  };
}
